export class ArrayMixin {
    map(mapFilter, context) {
        const { models } = this, { length } = models, res = Array(length), fun = context ? mapFilter.bind(context) : mapFilter;
        for (var i = 0, j = 0; i < length; i++) {
            const val = fun(models[i], i);
            val === void 0 || (res[j++] = val);
        }
        if (i !== j) {
            res.length = j;
        }
        return res;
    }
    each(fun, context) {
        const { models } = this, { length } = models, iteratee = context ? fun.bind(context) : fun;
        for (let i = 0; i < length; i++) {
            iteratee(models[i], i);
        }
    }
    firstMatch(doWhile, context) {
        const { models } = this, { length } = models, iteratee = context ? doWhile.bind(context) : doWhile;
        for (let i = 0; i < length; i++) {
            const res = iteratee(models[i], i);
            if (res !== void 0)
                return res;
        }
    }
    reduce(iteratee, init) {
        return init === void 0 ? this.models.reduce(iteratee) : this.models.reduce(iteratee, init);
    }
    slice(begin, end) {
        return this.models.slice(begin, end);
    }
    indexOf(modelOrId) {
        return this.models.indexOf(this.get(modelOrId));
    }
    includes(idOrObj) {
        return Boolean(this.get(idOrObj));
    }
    filter(iteratee, context) {
        const fun = toPredicateFunction(iteratee);
        return this.map(m => fun(m) ? m : void 0, context);
    }
    find(iteratee, context) {
        const fun = toPredicateFunction(iteratee);
        return this.firstMatch(m => fun(m) ? m : void 0, context);
    }
    some(iteratee, context) {
        return Boolean(this.find(iteratee, context));
    }
    forEach(iteratee, context) {
        this.each(iteratee, context);
    }
    values() {
        return this.models.values();
    }
    entries() {
        return this.models.entries();
    }
    every(iteratee, context) {
        const fun = toPredicateFunction(iteratee);
        return this.firstMatch(m => fun(m) ? void 0 : false, context) === void 0;
    }
    pluck(key) {
        return this.map(model => model[key]);
    }
    first() { return this.models[0]; }
    last() { return this.models[this.models.length - 1]; }
    at(a_index) {
        const index = a_index < 0 ? a_index + this.models.length : a_index;
        return this.models[index];
    }
}
const noOp = x => x;
function toPredicateFunction(iteratee) {
    if (iteratee == null)
        return noOp;
    switch (typeof iteratee) {
        case 'function': return iteratee;
        case 'object':
            const keys = Object.keys(iteratee);
            return x => {
                for (let key of keys) {
                    if (iteratee[key] !== x[key])
                        return false;
                }
                return true;
            };
        default: throw new Error('Invalid iteratee');
    }
}
//# sourceMappingURL=arrayMethods.js.map